import type { HttpBodyLanguage } from '@terra/ui-design-system';

export const getLanguageLabelFromPath = (filePath: string): string => {
  const extension = filePath.split('.').pop()?.toLowerCase();

  switch (extension) {
    case 'ts':
    case 'tsx':
      return 'typescript';
    case 'js':
    case 'jsx':
      return 'javascript';
    case 'vue':
      return 'vue';
    case 'py':
      return 'python';
    case 'java':
      return 'java';
    case 'go':
      return 'go';
    case 'rs':
      return 'rust';
    case 'php':
      return 'php';
    case 'rb':
      return 'ruby';
    case 'cs':
      return 'csharp';
    case 'cpp':
    case 'cc':
    case 'cxx':
      return 'cpp';
    case 'c':
      return 'c';
    case 'css':
      return 'css';
    case 'scss':
    case 'sass':
      return 'scss';
    case 'html':
    case 'htm':
      return 'html';
    case 'json':
      return 'json';
    case 'yaml':
    case 'yml':
      return 'yaml';
    case 'md':
      return 'markdown';
    case 'sql':
      return 'sql';
    case 'xml':
      return 'xml';
    default:
      return 'text';
  }
};

export const toHttpBodyLanguage = (filePath: string): HttpBodyLanguage => {
  const extension = filePath.split('.').pop()?.toLowerCase();

  switch (extension) {
    case 'json':
      return 'json';
    case 'js':
    case 'jsx':
    case 'ts':
    case 'tsx':
    case 'mjs':
    case 'cjs':
      return 'javascript';
    case 'vue':
    case 'html':
    case 'htm':
    case 'svelte':
      return 'html';
    case 'xml':
      return 'xml';
    case 'css':
    case 'scss':
    case 'sass':
      return 'css';
    case 'py':
      return 'python';
    default:
      return 'text';
  }
};
